import { render, staticRenderFns } from "./VendorPriceListPdf.vue?vue&type=template&id=b3075a62"
import script from "./VendorPriceListPdf.vue?vue&type=script&lang=js"
export * from "./VendorPriceListPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports